var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduationCapSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_313_8539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.19971C11.6962 1.19971 11.3962 1.25221 11.1112 1.35346L0.592467 5.15221C0.236217 5.28346 -3.31415e-05 5.62096 -3.31415e-05 5.99971C-3.31415e-05 6.37846 0.236217 6.71596 0.592467 6.84721L2.76372 7.63096C2.14872 8.59846 1.79997 9.74221 1.79997 10.946V11.9997C1.79997 13.0647 1.39497 14.1635 0.963717 15.0297C0.719967 15.5172 0.442467 15.9972 0.119967 16.4397C-3.31402e-05 16.601 -0.0337831 16.811 0.0337169 17.0022C0.101217 17.1935 0.258717 17.336 0.453717 17.3847L2.85372 17.9847C3.01122 18.026 3.17997 17.996 3.31872 17.9097C3.45747 17.8235 3.55497 17.681 3.58497 17.5197C3.90747 15.9147 3.74622 14.4747 3.50622 13.4435C3.38622 12.911 3.22497 12.3672 2.99997 11.8685V10.946C2.99997 9.81346 3.38247 8.74471 4.04622 7.88971C4.52997 7.30846 5.15622 6.83971 5.89122 6.55096L11.7787 4.23721C12.0862 4.11721 12.435 4.26721 12.555 4.57471C12.675 4.88221 12.525 5.23096 12.2175 5.35096L6.32997 7.66471C5.86497 7.84846 5.45622 8.12971 5.12247 8.47471L11.1075 10.6347C11.3925 10.736 11.6925 10.7885 11.9962 10.7885C12.3 10.7885 12.6 10.736 12.885 10.6347L23.4075 6.84721C23.7637 6.71971 24 6.37846 24 5.99971C24 5.62096 23.7637 5.28346 23.4075 5.15221L12.8887 1.35346C12.6037 1.25221 12.3037 1.19971 12 1.19971ZM4.79997 15.2997C4.79997 16.6235 8.02497 17.9997 12 17.9997C15.975 17.9997 19.2 16.6235 19.2 15.2997L18.6262 9.84721L13.2937 11.7747C12.8775 11.9247 12.4387 11.9997 12 11.9997C11.5612 11.9997 11.1187 11.9247 10.7062 11.7747L5.37372 9.84721L4.79997 15.2997Z",
    fill: "#AA182C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_313_8539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationCapSolid);
export default __webpack_public_path__ + "static/media/graduation-cap-solid.771d88fe0461eafe0a84a744e8a4dcf6.svg";
export { ForwardRef as ReactComponent };